import { createRoot } from "react-dom/client"
import "@fontsource-variable/inter"
import { StrictMode } from "react"
import { App } from "./App"

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
